import script from "./FooterComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./FooterComponent.vue?vue&type=script&setup=true&lang=ts"

import "./FooterComponent.vue?vue&type=style&index=0&id=3272582f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3272582f"]])

export default __exports__